import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { catchError, throwError } from 'rxjs';

import { AuthActions } from '../../state/auth/auth.actions';
import { getSessionToken } from '../utils/session.util';

/**
 * Attaches the stored session token as the `Authorization` header on https
 * calls, and forces JSON content-type on writes.
 *
 * The token lives in `sessionStorage` (written on login by `onLoginSuccess$`,
 * rehydrated into the store on refresh). If an authenticated call comes back
 * 401/403 — i.e. the token has expired or been revoked server-side — we log the
 * user out so they land back on the sign-in screen.
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const store = inject(Store);
  const authToken = getSessionToken();

  let request = req;
  if (authToken && req.url.startsWith('https')) {
    request = request.clone({ headers: request.headers.set('Authorization', authToken) });
  }
  if (req.method === 'POST' || req.method === 'PUT') {
    request = request.clone({ headers: request.headers.set('Content-Type', 'application/json') });
  }

  const isLoginCall = req.url.includes('/api/smartAsset/login');

  return next(request).pipe(
    catchError((err: unknown) => {
      if (
        !isLoginCall &&
        err instanceof HttpErrorResponse &&
        (err.status === 401 || err.status === 403)
      ) {
        store.dispatch(AuthActions.logout());
      }
      return throwError(() => err);
    }),
  );
};
